module.exports = __webpack_public_path__ + "static/img/g.9ea08e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/g.png
// module id = pN6P
// module chunks = 1